import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { Box, Tab, Tabs } from '@mui/material';

import PropTypes from 'prop-types';

import { PromocionesRecibidasScreen } from './PromocionesRecibidasScreen';
import { DemandasRecibidasScreen } from './DemandasRecibidasScreen';
import { BusquedaScreen } from './BusquedaScreen';

function TabPanel( props ){
    
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const TabsUsuarioInternoScreen = () => {

    const { esPenal } = useSelector( state => state.auth );

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
            
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant='scrollable' scrollButtons='auto' allowScrollButtonsMobile >
                    
                    <Tab label="Promociones recibidas" {...a11yProps(0)} />

                    {
                        esPenal === false
                        &&
                            <Tab label="Demandas recibidas" {...a11yProps(1)} />
                    }
                    
                    
                    <Tab label="Busqueda" {...a11yProps( esPenal === false ? 1 : 2 )} />

                </Tabs>

            </Box>

            <TabPanel value={value} index={0}>

                <PromocionesRecibidasScreen />

            </TabPanel>

            {
                esPenal === false
                &&
                    <TabPanel value={value} index={1}>

                        <DemandasRecibidasScreen />

                    </TabPanel>
            }          

            <TabPanel value={value} index={ esPenal === true ? 1 : 2 }>

                <BusquedaScreen />

            </TabPanel>
        </>
    )

}
